import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { FakeText, Typography } from '@totalsoft/rocket-ui';
import { Accordion, AccordionDetails, AccordionSummary, Grid, Tooltip, IconButton } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import IncomeSourceDetailComponent from './IncomeSourceDetailComponent';
import IncomeSourceDetailSummaryComponent from './IncomeSourceDetailSummaryComponent';
import { Delete, Save } from '@mui/icons-material';
import { isValid, getErrors } from '@totalsoft/pure-validations-react';

const IncomeSourceDetailListComponent = ({ incomeItemDetails, periodTypes, dataTypes, loading, dispatch, onSave, validation }) => {
  const { t } = useTranslation();
  const onExpandChange = (isExpanded, index) => {
    dispatch({ type: 'OnDetailExpanded', index, isExpanded });
  };

  const onSaveDetail = (item, idx) => {
    onSave('DetailAddOrUpdate', item, idx);
  };

  const onDeleteDetail = (item, idx) => {
    if (window.confirm(t('Tooltips.IncomeSource.DeleteDetail'))) {
      if (item.id !== null) {
        onSave('DetailDelete', { id: item.id }, idx);
      } else {
        dispatch({ type: 'OnDetailDeleted', index: idx });
      }
    }
  };

  return incomeItemDetails.map((item, idx) => {
    const header = <IncomeSourceDetailSummaryComponent incomeItemDetails={item} />;
    return (
      <Grid key={idx} item xs={12} sx={{ marginBottom: '35px!important' }}>
        <Accordion expanded={item.isExpanded} onChange={(_, isExpanded) => onExpandChange(isExpanded, idx)}>
          <AccordionSummary sx={{ width: '100%' }} expandIcon={<ExpandMoreIcon />}>
            {(item.isExpanded || (!item.isExpanded && !header)) && (
              <Grid container spacing={1} justifyContent='flex-end' onClick={event => event.stopPropagation()}>
                <Grid item>
                  <Tooltip title={t('IncomeSources.SaveChanges')}>
                    <div>
                      <IconButton
                        color='primary'
                        onClick={() => onSaveDetail(item, idx)}
                        disabled={!item.changed || !(validation[idx] |> isValid) || (validation |> getErrors) !== ''}
                      >
                        <Save />
                      </IconButton>
                    </div>
                  </Tooltip>
                </Grid>
                <Grid item>
                  <Tooltip title={t('Tooltips.IncomeSource.DeleteDetail')}>
                    <IconButton color='primary' onClick={() => onDeleteDetail(item, idx)}>
                      <Delete />
                    </IconButton>
                  </Tooltip>
                </Grid>
              </Grid>
            )}
            {!item.isExpanded && <div style={{ width: '100%' }}>{header}</div>}
          </AccordionSummary>
          <AccordionDetails>
            {loading ? (
              <FakeText lines={10} />
            ) : (
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <Typography color='error'>{validation |> getErrors}</Typography>
                </Grid>
                <IncomeSourceDetailComponent
                  incomeItemDetail={item}
                  index={idx}
                  periodTypes={periodTypes}
                  dataTypes={dataTypes}
                  dispatch={dispatch}
                  loading={loading}
                  onSave={onSave}
                  collectionValidation={validation}
                />
              </Grid>
            )}
          </AccordionDetails>
        </Accordion>
      </Grid>
    );
  });
};

IncomeSourceDetailListComponent.propTypes = {
  dispatch: PropTypes.func.isRequired,
  incomeItemDetails: PropTypes.array.isRequired,
  periodTypes: PropTypes.array,
  dataTypes: PropTypes.array,
  loading: PropTypes.bool,
  onSave: PropTypes.func.isRequired,
  validation: PropTypes.object.isRequired
};

export default IncomeSourceDetailListComponent;
